import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';
import { currentActorId } from '../utils/combat/combatEngine';
import { SPELLS } from '../utils/combat/spells';
import RunClock from './runClock';

// Heading shown over the status bar while a menu is in use, so the action
// panel below keeps the same button layout in and out of combat
function menuHeading({ spellcasting, combat, party }) {
  if (spellcasting) {
    if (spellcasting.stage === 'caster') return 'WHO WILL CAST?';
    if (spellcasting.stage === 'target') return `${SPELLS[spellcasting.spellId].name.toUpperCase()} — CAST ON WHOM?`;
    const caster = party.find((c) => c.id === spellcasting.casterId);
    return `${caster.name.toUpperCase()} — ${caster.sp} SP`;
  }
  if (combat) {
    const actor = party.find((c) => c.id === currentActorId(combat));
    return actor ? `${actor.name.toUpperCase()}'S TURN` : null;
  }
  return null;
}

class PartyStatus extends Component {
  render() {
    const heading = menuHeading(this.props.context);
    return (
      <div id="status">
        {heading && <div className="status-overlay">{heading}</div>}
        <RunClock />
        <span className="gold-status">{this.props.context.gold} GOLD</span>
        {this.props.context.hasKey && (
          <div className="key-status-icon">
            <span className="key-icon-small">KEY</span>
          </div>
        )}
      </div>
    );
  }
}

export default withContext(PartyStatus);